module.exports = __webpack_public_path__ + "img/2.full.c99eba28.webp";